<template>
  <div class="container-fluid py-4">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4">
          <div class="card-header pb-0">
            <div class="row mb-3 align-items-center">
              <div class="col-md-6">
                <h3 class="mb-0 text-center">Contact</h3>
              </div>
              <div class="col-md-4">
                <div class="input-group">
                  <span class="input-group-text text-body"><i class="fas fa-search" aria-hidden="true"></i></span>
                  <input type="text" class="form-control" v-model="search"
                    placeholder="Rechercher par prénom, nom ou téléphone" />
                </div>
              </div>
            </div>
          </div>

          <div class="table-responsive p-0">
            <table id="tableau-contacts" class="table align-items-center mb-0">
              <thead>
                <tr>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Prénom</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Nom</th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Téléphone</th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Options</th>
                  <th class="text-secondary opacity-7"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="contact in paginatedContacts" :key="contact.id">

                  <td>
                    <div class="d-flex px-2 py-1">
                      <div class="d-flex flex-column justify-content-center">
                        <h6 class="mb-0 text-sm">{{ contact.firstname }}</h6>
                        <p class="text-xs text-secondary mb-0">{{ contact.email }}</p>
                      </div>
                    </div>
                  </td>

                  <td>
                    <p class="text-xs font-weight-bold mb-0">{{ contact.lastname }}</p>

                  </td>

                  <td class="align-middle text-center">
                    <p class="text-xs font-weight-bold mb-0">{{ contact.telephone }}</p>
                  </td>

                  <td class="align-middle text-center">
                    <router-link :to="{ name: 'Details du Contact', params: { id: contact.id } }"
                      class="text-secondary font-weight-bold text-xs px-3">
                      <i class="fa-solid fa-circle-info text-primary me-0" aria-hidden="true"></i>
                      Details
                    </router-link>
                    <router-link :to="{ name: 'Modifier un Contact', params: { id: contact.id } }"
                      class="text-secondary font-weight-bold text-xs px-3">
                      <i class="fa fa-pencil-alt text-dark me-0" aria-hidden="true"></i>
                      Modifier
                    </router-link>

                    <a href="#" class="text-secondary font-weight-bold text-xs px-3" @click="deleteContact(contact.id)">
                      <i class="fa-solid fa-trash text-danger me-0" aria-hidden="true"></i>
                      Supprimer
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
            <nav>

              

              <ul class="pagination text-center">
                <div class="col-md-6">
                  <p class="text-primary"> Affichage de {{ (currentPage - 1) * itemsPerPage + 1 }} à
                    {{ Math.min(currentPage * itemsPerPage, filteredContacts.length) }}
                    sur {{ filteredContacts.length }} contacts
                  </p>
                </div>
             

                <button class="btn btn-link" @click.prevent="prevPage" :disabled="currentPage === 1">Précédent</button>
      
                <li class="page-item" v-for="page in pages" :key="page" :class="{ 'active': currentPage === page }">
                  <a class="page-link" @click.prevent="setPage(page)" href="#">{{ page }}</a>

                </li>

                <button class="btn btn-link" @click.prevent="nextPage" :disabled="currentPage === totalPages">Suivant</button>

              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import { userService } from '@/_services';

export default {
  data() {
    return {
      contacts: [],
      search: '',
      currentPage: 1,
      itemsPerPage: 10,
    };
  },
  created() {
    this.loadContacts();
  },
  computed: {
    filteredContacts() {
      return this.contacts.filter(contact => 
        contact.firstname.toLowerCase().includes(this.search.toLowerCase()) ||
        contact.lastname.toLowerCase().includes(this.search.toLowerCase()) ||
        contact.telephone.toLowerCase().includes(this.search.toLowerCase())
      );
  },
    totalPages() {
      return Math.ceil(this.filteredContacts.length / this.itemsPerPage);
    },
    pages() {
      return Array.from({ length: this.totalPages }, (_, i) => i + 1);
    },
    paginatedContacts() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      return this.filteredContacts.slice(startIndex, endIndex);
    },
  },

  methods: {
    setPage(page) {
      this.currentPage = page;
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    async loadContacts() {
      try {
        const response = await userService.getAllUsers();
        this.contacts = response.data;
      } catch (error) {
        console.error('Erreur lors du chargement des utilisateurs :', error);
      }
    },

    async deleteContact(id) {
      try {
        await userService.deleteContactById(id);
        this.loadContacts();
      } catch (error) {
        console.error('Erreur lors de la suppression du contact :', error);
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>